import { render, staticRenderFns } from "./UploadAlbumView.vue?vue&type=template&id=bfaa2a62&"
import script from "./UploadAlbumView.vue?vue&type=script&lang=ts&"
export * from "./UploadAlbumView.vue?vue&type=script&lang=ts&"
import style0 from "./UploadAlbumView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports